import { useState, useMemo } from "react";
import "./TabelaReembolso.css";
import { FaDownload } from "react-icons/fa";
import { downloadExtratoById } from "../../../../../services/ExtractService";
import { downloadArquivoExtratoSolicitacao } from "../../../../../services/FinanceiroService";
import { Spinner } from "react-bootstrap";

const EMPTY = [];

const TabelaReembolso = ({
  TabelaReembolso = EMPTY,
  idSindicato,
  extratoSolicitacaoId = null,
}) => {
  const parcelas = useMemo(
    () => (Array.isArray(TabelaReembolso) ? TabelaReembolso : EMPTY),
    [TabelaReembolso],
  );

  const [downloading, setDownloading] = useState(false);

  const formatarValor = (valor) =>
    (Number(valor) || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

  const valorTotal = parcelas.reduce(
    (total, p) => total + (Number(p?.valor) || 0),
    0,
  );

  const handleDownloadExtrato = async (e) => {
    e.preventDefault();
    if (downloading) return;
    setDownloading(true);
    try {
      if (extratoSolicitacaoId != null && extratoSolicitacaoId !== "") {
        await downloadArquivoExtratoSolicitacao(
          extratoSolicitacaoId,
          `extrato_${extratoSolicitacaoId}.pdf`,
        );
        return;
      }

      const ret = await downloadExtratoById(idSindicato);
      const { url } = typeof ret === "string" ? { url: ret } : ret || {};
      if (!url)
        throw new Error("Extrato não encontrado ou resposta inválida.");
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Erro ao abrir extrato:", err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="card shadow-sm p-4 mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold text-uppercase m-0">
          Informações completas para o reembolso
        </h5>

        <button
          className="btn-primario btn-acao d-flex align-items-center gap-2"
          disabled={downloading}
          onClick={handleDownloadExtrato}
        >
          {downloading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span>Gerando...</span>
            </>
          ) : (
            <>
              <FaDownload size={14} />
              Baixar Extrato
            </>
          )}
        </button>
      </div>

      <div className="table-responsive">
        <table className="table tabela-reembolso mb-0">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Valor</th>
            </tr>
          </thead>

          <tbody>
            {parcelas.map((parcela, index) => (
              <tr key={index}>
                <td>{parcela.descricao?.toUpperCase()}</td>
                <td>{formatarValor(parcela.valor)}</td>
              </tr>
            ))}

            <tr>
              <td className="fw-bold">VALOR TOTAL LÍQUIDO</td>
              <td className="fw-bold">{formatarValor(valorTotal)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TabelaReembolso;
